module.exports = __webpack_public_path__ + "img/itsslc.b6f0d369.svg";